// extracted by mini-css-extract-plugin
export default {"ImageList":"ImageList_ImageList__N3FUa","next":"ImageList_next__H-ZTk"};